/* eslint-disable react-hooks/exhaustive-deps */
import {
  DownOutlined,
  EditOutlined,
  FileAddOutlined,
  HddFilled,
} from "@ant-design/icons";
import { PageHeader } from "@ant-design/pro-layout";
import {
  Button,
  Card,
  Col,
  Dropdown,
  MenuProps,
  Modal,
  Row,
  Table,
  Tag,
} from "antd";
import FiltersComponent from "components/FiltersComponent";
import { BaseShippingCategoryDataStatus } from "enums/baseShippingCategoryCollectionEnums";
import useDataFilters from "hooks/useDataFilters";
import { useAtom } from "jotai";
import { useGetBaseShippingCategory } from "lib/core-react/hooks/private";
import { baseShippingCategoryAtom } from "lib/core-react/store/store";
import {
  BaseShippingCategoryDataModel,
  BaseShippingCategoryModel,
} from "models/baseShippingCategory";
import { PaginationModel } from "models/pagination";
import { useState, useEffect } from "react";
import { IFilterType } from "types/filters";
import UpdateBaseShippingCategory from "./components/UpdateBaseShippingCategory";
import CreateBaseShippingCategory from "./components/CreateBaseShippingCategory";
import AddChildren from "./components/AddChildren";
import { ApiHelperModel } from "models/apiHelper";
import {StatusTag} from "../../../components";
import useWindowWidth from "../../../lib/core-react/hooks/public/useWindowWidth";
const { Column } = Table;
const BaseShippingCategory = () => {
  const {isMobile} = useWindowWidth()
  const { getBaseShippingCategory } = useGetBaseShippingCategory();
  const [{ data: baseShippingData, isLoading, refetch }] = useAtom(
    baseShippingCategoryAtom,
  );
  const {
    filters,
    handleFilterChange,
    handelFilterClear,
    isFirstCall,
    isFetched,
    initializeAvailableFilter,
  } = useDataFilters();

  // Api Call
  useEffect(() => {
    if ((filters && !isFetched && isFirstCall) || refetch) {
      filters &&
        ApiHelperModel.makeGetRequest(filters, getBaseShippingCategory);
    }
  }, [isFirstCall, filters, isFetched, refetch]);

  // Base Shipping category
  const BaseShippingCategory =
    baseShippingData && new BaseShippingCategoryModel(baseShippingData);

  // Filter
  let filterData = BaseShippingCategory?.filters;

  // Getting all available filters
  useEffect(() => {
    if (!isFetched && BaseShippingCategory?.filters) {
      initializeAvailableFilter(filterData as IFilterType);
    }
  }, [isFetched, initializeAvailableFilter, BaseShippingCategory?.filters]);

  // Add Child
  const [isShowAddChildModal, setIsShowAddChildModal] =
    useState<boolean>(false);
  const [addChildPayload, setAddChildPayload] = useState<
    BaseShippingCategoryDataModel | undefined
  >(undefined);
  // Show Add child modal with data
  const showAddChildModal = (record: any) => {
    setAddChildPayload(record);
    setIsShowAddChildModal(true);
  };
  // Create
  const [isShowCreateModal, setIsShowCreateModal] = useState<boolean>(false);

  //Update
  const [isShowUpdateModal, setIsShowUpdateModal] = useState<boolean>(false);
  const [updatePayload, setUpdatePayload] = useState<
    BaseShippingCategoryDataModel | undefined
  >(undefined);

  // Show update modal with data
  const showUpdateModal = (record: any) => {
    setUpdatePayload(record);
    setIsShowUpdateModal(true);
  };

  // Pagination Handler
  const handlePaginationChange = (pageCount: number, pageSize: number) => {
    const pageInfo = { page: pageCount, per_page: pageSize };
    handleFilterChange(pageInfo);
    ApiHelperModel.makeGetRequest(
      {
        ...filters,
        ...pageInfo,
      },
      getBaseShippingCategory,
    );
  };

  // Pagination Configuration
  const paginationConfig = PaginationModel.getPaginationConfig(
    BaseShippingCategory,
    handlePaginationChange,
  );

  // Filter Handler
  const handleProductFilter = () => {
    filters && ApiHelperModel.makeGetRequest(filters, getBaseShippingCategory);
  };

  return (
    <>
      <div>
        <PageHeader
          ghost={false}
          title="Base Shipping Category"
          style={{ marginTop: "10px" }}
          extra={[
            <Button
              key="1"
              type="primary"
              onClick={() => setIsShowCreateModal(true)}
            >
              Create Base Shipping Category
            </Button>,
          ]}
        >
          <div>
            {filters && Object.keys(filters).length > 0 && (
              <Row>
                <Col span={24}>
                  <Card title="Base Shipping Country">
                    <FiltersComponent
                      handleProductFilter={handleProductFilter}
                      handleFilterChange={handleFilterChange}
                      handelFilterClear={handelFilterClear}
                      isFetched={isFetched}
                      filters={filters}
                      filtersData={filterData}
                      isFromProductReceived={true}
                    />
                  </Card>
                </Col>
              </Row>
            )}
            <Table
              style={{ marginTop: "15px" }}
              bordered
              loading={isLoading}
              rowKey="id"
              pagination={paginationConfig}
              dataSource={BaseShippingCategory?.data}
              scroll={{ x: 1000 }}

            >
              <Column title="Name" dataIndex="name" key="name" />

              <Column title="Slug" dataIndex="slug" key="slug" />
              <Column
                title="Status"
                dataIndex="status"
                key="status"
                render={(_, record: BaseShippingCategoryDataModel) => (
                  <StatusTag  text={record.status} slug={record.status}/>
                )}
              />
              <Column
                title="Action"
                key="action"
                fixed = {isMobile ? "right" : undefined}
                align = "center"
                width = {100}
                render={(_, record) => {
                  const items: MenuProps["items"] = [
                    {
                      key: "1",
                      label: (
                        <div
                          style={{ cursor: "pointer" }}
                          onClick={() => showUpdateModal(record)}
                        >
                          <EditOutlined /> <span> Update</span>
                        </div>
                      ),
                    },
                    {
                      key: "2",
                      label: (
                        <div
                          style={{ cursor: "pointer" }}
                          onClick={() => showAddChildModal(record)}
                        >
                          <FileAddOutlined /> <span> Add Child</span>
                        </div>
                      ),
                    },
                  ];

                  return (
                    <Dropdown menu={{ items }}>
                      <Button icon={<HddFilled />}>
                        {isMobile ? (
                          <DownOutlined />
                        ) : (
                          <>
                            Actions <DownOutlined />{" "}
                          </>
                        )}
                      </Button>
                    </Dropdown>
                  );
                }}
              />
            </Table>
          </div>
        </PageHeader>
      </div>

      <Modal
        title={`Create Base Shippinng Category`}
        open={isShowCreateModal}
        footer={false}
        onCancel={() => setIsShowCreateModal(false)}
      >
        <CreateBaseShippingCategory
          setIsShowCreateModal={setIsShowCreateModal}
        />
      </Modal>

      <Modal
        title={`Update Base Shippinng Category`}
        open={isShowUpdateModal}
        footer={false}
        onCancel={() => setIsShowUpdateModal(false)}
      >
        <UpdateBaseShippingCategory
          setIsShowUpdateModal={setIsShowUpdateModal}
          data={updatePayload as BaseShippingCategoryDataModel}
        />
      </Modal>
      <Modal
        title={`Add Children`}
        open={isShowAddChildModal}
        footer={false}
        onCancel={() => setIsShowAddChildModal(false)}
      >
        <AddChildren
          setIsShowAddChildModal={setIsShowAddChildModal}
          data={addChildPayload as BaseShippingCategoryDataModel}
        />
      </Modal>
    </>
  );
};

export default BaseShippingCategory;
